import React, { HTMLAttributes } from 'react';
import { InfoText } from './PortalDocumentsList.styles';
import SignMenu from './SignMenu';
import { ActionMenu } from 'src/components/Menus';
import { useUrlParameterCheck } from 'src/utils/useUrlParameterCheck';
import { t } from 'i18next';

interface IDocumentListActions extends HTMLAttributes<HTMLElement> {
  canSign: boolean;
  onReject: () => void;
  onSign: () => void;
}

const DocumentListActions = ({
  canSign,
  onReject,
  onSign,
  ...rest
}: IDocumentListActions) => {
  const isFromMvpApp = useUrlParameterCheck('/app');

  return (
    <ActionMenu
      style={{
        width: isFromMvpApp ? '100%' : 'auto',
        marginTop: isFromMvpApp ? 'auto' : '0',
        padding: isFromMvpApp ? '0' : '10px 20px',
      }}
      {...rest}
      leftSide={
        isFromMvpApp ? null : (
          <InfoText text={t('YouMustReviewAllDocumentsBeforeSigning')} />
        )
      }
      rightSide={
        <SignMenu canSign={canSign} onReject={onReject} onSign={onSign} />
      }
    />
  );
};

export default DocumentListActions;
